import React, { Component } from "react";
import cx from "classnames";
import { themr } from "analytics-ui/theme/themr";

import calendarIcon from "./assets/calendar.svg";
import refreshIcon from "./assets/refresh.svg";
import presets from "./constants/presets";
import Styles from "./DateRangePicker.module.scss";
import DrpPopover from "./DrpPopover/DrpPopover";
import SvgIcon from "../SvgIcon";
import XbertTooltip from "analytics-ui/XbertTooltip/XbertTooltip";
import { setDateRangeEndToNow } from "utils/date";
import DateRangeLabel from "analytics-ui/DateRangeLabel/DateRangeLabel";

class DateRangePicker extends Component {
  static defaultProps = {
    dateRange: {
      type: "relative",
      ...presets.Today,
    },
    timezone: "",
    isRealTime: false,
    isOpen: false,
    onChange: () => {},
    onChangeCancel: (error) => alert(error.message),
    onRealTimeChange: () => {},
    isDarkTheme: false,
    realTimeTooltipMessage: "Click icon for real-time",
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && prevState.isRealTime !== nextProps.isRealTime) {
      return {
        isRealTime: nextProps.isRealTime,
      };
    }
    return null;
  }

  state = {
    isRealTime: this.props.isRealTime || false,
  };

  componentDidMount() {
    if (this.props.isRealTime) {
      this.changeEndToNow();
    }
  }

  changeEndToNow = () => {
    const { dateRange, onChange } = this.props;
    onChange(setDateRangeEndToNow(dateRange));
  };

  handleChange = (dateRange) => {
    const { isRealTime, onChange } = this.props;
    if (isRealTime) {
      dateRange = setDateRangeEndToNow(dateRange);
    }
    onChange(dateRange);
  };

  handleToggleRealTime = () => {
    this.setState((state) => {
      const isRealTime = !state.isRealTime;
      this.changeEndToNow();
      this.props.onRealTimeChange(isRealTime);
      return { isRealTime };
    });
  };

  render() {
    const {
      className,
      bodyClassName,
      dateRange,
      timezone,
      theme,
      startDateFormat,
      endDateFormat,
      withRealTimeIcon,
      isPeriod,
      onChangeCancel,
      relativeUnits,
      isDarkTheme,
      disabled,
      isOpen,
      realTimeTooltipMessage,
      isShareMode,
      presets,
    } = this.props;

    const { isRealTime } = this.state;

    return (
      <div className={theme.dateRangePicker}>
        {isShareMode ? (
          <DateRangeLabel
            dataTest="date-range-picker-label"
            dateRange={dateRange}
            timezone={timezone}
            startDateFormat={startDateFormat}
            endDateFormat={endDateFormat}
            isRealTime={isRealTime}
            isDarkTheme={isDarkTheme}
          />
        ) : (
          <DrpPopover
            bodyClassName={bodyClassName}
            className={className}
            presets={presets}
            dateRange={dateRange}
            timezone={timezone}
            isPeriod={isPeriod}
            isRealTime={isRealTime}
            relativeUnits={relativeUnits}
            onChange={this.handleChange}
            onChangeCancel={onChangeCancel}
            disabled={disabled}
            isOpen={isOpen}
          >
            <SvgIcon className={theme['calendar-icon']} src={calendarIcon} />
            <DateRangeLabel
              dataTest="date-range-picker-label"
              dateRange={dateRange}
              timezone={timezone}
              startDateFormat={startDateFormat}
              endDateFormat={endDateFormat}
              isRealTime={isRealTime}
              isDarkTheme={isDarkTheme}
            />
            {withRealTimeIcon && (
              <XbertTooltip
                tipContent={realTimeTooltipMessage}
                tipId="date-range-tip"
                theme={{ xbertTooltip: theme.overrideXbertTooltip }}
                tipItem={
                  <SvgIcon
                    className={cx(theme['real-time'], {
                      [theme['real-time-active']]: isRealTime,
                    })}
                    src={refreshIcon}
                    onClick={this.handleToggleRealTime}
                  />
                }
              />
            )}
          </DrpPopover>
        )}
      </div>
    );
  }
}

const DateRangePickerWithTheme = themr(DateRangePicker, Styles);
export default DateRangePickerWithTheme;
